class BookSpecialCondition {
  id?: string;
  name?: string;
  i18nKey?: string;

  constructor(data: Partial<BookSpecialCondition>) {
    this.id = data.id;
    this.name = data.name
    this.i18nKey = data.i18nKey;
  }

  static initFeaturedBooksCondition() {
    return new BookSpecialCondition(
      {
        id: "1_hot_title",
        name: "featured_books",
        i18nKey: "pages/pubTop:hotTitles"
      }
    );
  }

  static initNewReleaseCondition() {
    return new BookSpecialCondition(
      {
        id: "2_new_release",
        name: "new_release",
        i18nKey: "pages/pubTop:newRelease"
      }
    );
  }

  static initBeforeDeadlineCondition() {
    return new BookSpecialCondition(
      {
        id: "3_closing_auction",
        name: "before_deadline",
        i18nKey: "pages/pubTop:closingAuction"
      }
    )
  }

  static initByName(name: string) {
    switch (name) {
      case "featured_books":
        return BookSpecialCondition.initFeaturedBooksCondition();
      case "new_release":
        return BookSpecialCondition.initNewReleaseCondition();
      case "before_deadline":
        return BookSpecialCondition.initBeforeDeadlineCondition();
      default:
        throw new Error(`Invalid special condition name: ${name}`);
    }
  }

  get attributes() {
    return {
      id: this.id,
      name: this.name,
      i18nKey: this.i18nKey
    }
  }

  get isFeaturedBooks() { return this.name === "featured_books"; }
  get isNewRelease() { return this.name === "new_release"; }
  get isBeforeDeadline() { return this.name === "before_deadline"; }
}

export default BookSpecialCondition;
